import { Paper, Stack, Typography } from '@mui/material'
import { WorkflowAppLogo } from '@/components/ConnectionApps/WorkflowAppLogo/WorkflowAppLogo.jsx'
import styles from './integrationsModal.module.scss'

/**
 * @param {{
 *   app: object,
 *   onConnect?: (slug: string) => void,
 *   isConnecting?: boolean,
 * }} props
 */
export default function IntegrationCard({ app, onConnect = () => {}, isConnecting = false }) {
  const clickable = app.canConnect && !app.isConnected && !isConnecting
  const connect = () => { if (clickable) onConnect(app.slug) }
  return (
    <Paper elevation={0} className={styles.integrationCard} role="button" tabIndex={clickable ? 0 : -1} aria-disabled={!clickable} onClick={connect} onKeyDown={(event) => { if (event.key === 'Enter' || event.key === ' ') connect() }}>
      <Stack direction="row" spacing={1} alignItems="center" className={styles.integrationCardInner}>
        <WorkflowAppLogo
          variant="integration"
          iconUrl={app.icon}
          pillKind={app.slug}
          displayName={app.title}
        />
        <Stack spacing={0} className={styles.integrationCardText}>
          <Typography component="h4" className={styles.integrationCardTitle}>
            {app.title}
          </Typography>
          {app.isConnected ? <Typography component="span" className={styles.integrationCardStatus}>Connected</Typography> : null}
        </Stack>
      </Stack>
    </Paper>
  )
}
